/*	assets/script.js	*/

// jQuery to collapse the navbar on scroll
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".navbar-fixed-top").addClass("top-nav-collapse");
        $(".navbar-brand img").addClass("logo-max-height");
    } else {
        $(".navbar-fixed-top").removeClass("top-nav-collapse");
        $(".navbar-brand img").removeClass("logo-max-height");
    }
});

// jQuery to vertically, horizontally align banner text
$('.vertical-outer').css({'height':($(document).height())+'px'});




$('#product-thumbs').delegate('img','click', function(){
	$('#large-image').attr('src',$(this).attr('src'));
	$('#featured').attr('href',$(this).attr('src'));
});

$( "#AddToCart" ).click(function() {
  //event.preventDefault();
  $('#Password').prop("disabled", false);
  $('#Email').prop("disabled", false);
});
